<script setup>
import { get, post, validators } from '@/common/util'
import { useMetaStore } from '@/stores'
import _ from 'lodash-es'
import { reactive } from 'vue'
import { useI18n } from 'vue-i18n'
import Draggable from 'vuedraggable'
const metaStore=useMetaStore(),i18n=useI18n(),meta=reactive({jobttls:[],drag:false,acts:[{tk:'initialize',color:''},{tk:'add',color:'warning'},{tk:'save',color:'primary'}]})
,pop=tk=>{
  meta.jobttlnm=meta.popto=null
  meta.actkey=tk
  if(tk=='initialize')meta.actcon='init_con'
  else if(tk=='delete')meta.actcon='del_con'
  else if(tk=='modify')meta.jobttlnm=meta.jobttls[meta.selidx].nm
  else if(tk=='save')meta.actcon='save_con'
  metaStore.pop({ison:true,callback:() => {
    const act=_.find(meta.acts,{tk:tk})
    meta.popto='#popbody'
  }})
},act=()=>{
  const key=meta.actkey
  if(['add','modify'].includes(key)&&meta.jobttls.findIndex(node=>node.name==meta.jobttlnm)>=0)
    return metaStore.toast(i18n.t('nm_already_taken'),false)
  if(key=='add'){
    if(meta.jobttls.some(jt=>jt.nm==meta.jobttlnm)){
      metaStore.toastKey('jobttl_already_taken')
    }else meta.jobttls.push({nm:meta.jobttlnm})
  }else if(key=='modify'){
    meta.jobttls[meta.selidx].nm=meta.jobttlnm
  }else if(key=='delete'){
    meta.jobttls.splice(meta.selidx,1)
  }else if(key=='save'){
    post('rest/authed/admin/resetjobttls',meta.jobttls.map((jt,idx)=>({nm:jt.nm,ord:idx}))
      ,res=>{
        metaStore.toast(i18n.t('thesaveiscomplete')+' : '+res.data)
        init()
      })
  }else if(key=='initialize')init()
  metaStore.pop({ison:false})
},init=()=>{
  get('rest/authed/member/jobttls',res=>meta.jobttls=_.orderBy(res.data,'ord','asc'))
}
init()
</script>
<template>
  <v-card class="ma-2" flat>
    <v-card-title class="d-flex align-center pe-2">
      <v-container>
        <v-row no-gutters>
          <v-col>{{ $t('man_jobtitle') }}</v-col>
        </v-row>
        <v-row>
          <v-col v-for="act in meta.acts">
            <v-btn block :text="$t(act.tk)" :color="act.color" @click.stop="pop(act.tk)"/>
          </v-col>
        </v-row>
      </v-container>
    </v-card-title>
    <v-divider/>
    <v-card-text>
      <v-container>
        <Draggable v-model="meta.jobttls" item-key="id">
          <template #item="{element,index}">
            <v-card class="ma-1">
              <v-card-text>
                <v-row>
                  <v-col class="text-h5">{{ element.nm }}</v-col>
                  <v-col cols="2">
                    <v-btn block :text="$t('modify')" color="info" @click="meta.selidx=index;pop('modify')"/>
                  </v-col>
                  <v-col cols="2">
                    <v-btn block :text="$t('delete')" color="error" @click="meta.selidx=index;pop('delete')"/>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </template>
        </Draggable>
      </v-container>
    </v-card-text>
  </v-card>
  <Teleport v-if="meta.popto" :to="meta.popto">
    <v-card class="mx-auto" min-width="340" :title="$t('jobtitle')+' '+$t(meta.actkey)">
      <v-divider/>
      <v-card-text>
        <v-text-field v-if="['add','modify'].includes(meta.actkey)" v-model="meta.jobttlnm" variant="outlined" :label="$t('jobtitle')" :placeholder="$t('pleaseenteryourjobtitle')" :rules="[validators.required]"/>
        <div v-else>{{ $t(meta.actcon) }}</div>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-row justify="end">
          <v-btn :text="$t('cancel')" variant="outlined" @click.stop="metaStore.pop({ison:false})"/>
          <v-btn :text="$t('confirm')" class="ms-2 me-3" variant="elevated" color="primary" @click.stop="act" :disabled="['add','modify'].includes(meta.actkey)&&validators.required(meta.jobttlnm)!==true"/>
        </v-row>
      </v-card-actions>
    </v-card>
  </Teleport>
  </template>

